import { useState } from 'react';
import Modal from '../../../../../components/modals/Modal';
import MaterialIcons from '../../../../../components/ui/icons/MaterialIcons';
import ImageDisplay from '../../../../private/examenes/ImageDisplay';
import UploadFile from '../../../utils/UploadFile';
import EditCard from '../EditCard';
import type { Question as IQuestion } from '../../../../../data/interface-question';

interface VEImageProps {
	question: IQuestion;
	onUpdate: (
		questionID: string,
		key: string,
		newValue: any
	) => Promise<IQuestion | null>;
}

const ViewEditImage = ({ question, onUpdate }: VEImageProps) => {
	const [edit, setEdit] = useState(false);
	const [imagePath, setImagePath] = useState<string>(question.imageFileName);

	const hasImage =
		typeof question.imageFileName === 'string' &&
		question.imageFileName.trim() !== '';

	const handleUpdate = () => {
		onUpdate(question.id, 'imageFileName', imagePath)
			.then(() => setEdit(false))
			.catch((error) => console.error('Error updating question:', error));
	};

	const handleDelete = () => {
		onUpdate(question.id, 'imageFileName', undefined)
			.then(() => setEdit(false))
			.catch((error) => console.error('Error updating question:', error));
	};

	return (
		<>
			<EditCard label='Imagen' onEdit={setEdit}>
				<div className='w-full flex flex-col items-center'>
					{hasImage ? (
						<div className='w-full max-w-xl mt-4'>
							<div className='flex flex-col justify-between items-center'>
								<ImageDisplay imagePathName={question.imageFileName} />
								<button
									className='rounded bg-red-500 p-1 text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500 ml-5 px-4 flex items-center gap-2'
									type='button'
									onClick={handleDelete}>
									<MaterialIcons
										icon='delete'
										classes='text-white text-lg'
										title='Eliminar'
									/>
									Eliminar
								</button>
							</div>
						</div>
					) : (
						<div className='w-full max-w-xl border-2 border-dashed border-gray-300 rounded-lg p-8 flex flex-col items-center justify-center bg-gray-50'>
							<MaterialIcons
								icon='image'
								classes='text-5xl text-gray-400 mb-4'
								title='Imagen'
							/>
							<button
								type='button'
								className='text-brand-600 font-semibold hover:underline focus:outline-none mb-1'
								onClick={() => setEdit(true)}>
								{hasImage ? 'Editar imagen' : 'Subir una imagen'}
							</button>
							{/* <span className='text-gray-500 text-sm'>
							o arrastra y suelta (no obligatorio)
						</span> */}
							<span className='text-xs text-gray-400'>
								PNG, JPG, GIF hasta 10MB
							</span>
						</div>
					)}
				</div>
			</EditCard>

			<Modal
				actionBtnText='Agregar'
				handleAction={handleUpdate}
				headline='Agrega una Imagen'
				isOpen={edit}
				onClose={() => setEdit(false)}
				showCloseBtn={true}>
				<UploadFile
					onUpload={(imgPath: string) => setImagePath(imgPath)}
					storageFolder='question-images'
					fileName={imagePath}
					fileType='image'
				/>
			</Modal>
		</>
	);
};
export default ViewEditImage;
